import setReduxAction from 'modules/redux/actions/set/index.js'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str/index.js'
import {
  STRIPE_KEY,
  STRIPE_PATH
} from 'modules/stripe/redux/constants/index.js'

export function updateTokenIdStripeAction (value) {
  const key = STRIPE_KEY.TOKEN_ID
  return setReduxAction({
    type: getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.UPDATE,
      key
    ),
    payload: {
      path: STRIPE_PATH[key],
      value
    }
  })
}
